import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'userTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedUser: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedUser
} = stateSlice.actions

export default stateSlice.reducer
